import { render } from "./Definition.vue?vue&type=template&id=c3f70208"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"

import "./Definition.vue?vue&type=style&index=0&id=c3f70208&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__